module.exports = __webpack_public_path__ + "assets/28c0688992c49a0bccad8f80338044e2.svg";